export default {
  methods: {
    signout (route) {
      
      route = route || 'login';
    
      return AppData.$store.dispatch('signout')
      .then(data => {
        this.$router.replace({ name: route });
        return Promise.resolve(true);
      })
      .catch(e => {
        this.$router.replace({ name: route });
        console.log('signoutMixin - dispatch(logout) Error - ', e);
        return Promise.reject(e);        
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/signoutMixin.js